export const getDateTimeFromDateTimePartials = (dateComponents: Date, timeComponents: Date) => new Date(
    dateComponents.getFullYear(),
    dateComponents.getMonth(),
    dateComponents.getDate(),
    timeComponents.getHours(),
    timeComponents.getMinutes(),
    timeComponents.getSeconds()
);
